












































import { Component, Inject, Prop, Vue } from 'vue-property-decorator'

@Component({})
export default class ModalNotificationUser extends Vue {
  @Prop() isActiveModalInfo: boolean

  @Inject() publishDocument
  @Inject() setActiveNotificationModal

  closeDialog() {
    this.setActiveNotificationModal(false)
  }
}
